import Api from '../api';

export const getTheLastSale = async () => {
  const response = await Api.get(`/api/controle_crm/get_the_last_sale`);

  return response.data;
};
